import React, {
    useCallback, useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Button } from '@jutro/components';
import { SgWebchatUtil } from 'saga-modules';
import messages from './SgIntercomWebchat.messages';

function SgIntercomWebchat() {
    const translator = useContext(TranslatorContext);

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    return (
        <>
            <Button onClick={trackChat} className="chat-icon-btn saga-intercom" id="intercomWebchatButton">
                <span className="chat-text">{translator(messages.ChatWithUs)}</span>
                <i className="chat-icon" />
            </Button>
        </>
    );
}
export default SgIntercomWebchat;
